import api from './base/standardApi';

export default {

  getCategory() {
    return api.get( 'api/categoria' );
  },
  postContact( data:any ) {
    return api.post( 'api/contactar', data );
  },
};
